
import React, { createContext, useState, useMemo } from 'react';

export const VolumeContext = createContext();

export const VolumeProvider = ({ children }) => {
  const [volume, setVolume] = useState(0.5); // Volume par défaut à 50%

  const value = useMemo(() => ({
    volume,
    setVolume,
  }), [volume]);

  return (
    <VolumeContext.Provider value={value}>
      {children}
    </VolumeContext.Provider>
  );
};
